import { AbstractControl, ValidatorFn } from "@angular/forms";

export const rolesKey = {
	user: "user",
	establishment: "establishment",
	admin: "admin",
	root: "root",
	rider: "rider",
};
export const rolesLabels = [{ id: 1, label: "Admin", key: "root" }];

export const statuses = [
	{ label: "Activo", value: true },
	{ label: "Inactivo", value: false },
];

export const statusAll = [
	{ label: "Aprobar", value: 1 },
	{ label: "Rechazar", value: 0 },
];

export const daysOfWeek = [
	{ label: "Lunes", value: "mon" },
	{ label: "Martes", value: "tue" },
	{ label: "Miércoles", value: "wed" },
	{ label: "Jueves", value: "thu" },
	{ label: "Viernes", value: "fri" },
	{ label: "Sábado", value: "sat" },
];

export const baseTypes = [
	{ label: "URL", value: "url" },
	{ label: "PDF", value: "pdf" },
];

export const places = [
	{ label: "BALEARIC_ISLANDS", value: "baleares" },
	{ label: "REST_OF_SITES", value: "resto" },
];

export const languages = [
	{
		label: "SPANISH",
		name: "Español",
		code: "ES",
		value: "esp",
		image: "assets/img/esp.png",
	},
	{
		label: "MONTENEGRIN",
		name: "Montenegrino",
		code: "MON",
		value: "mon",
		image: "assets/img/mon.png",
	},
	{
		label: "ALBANIAN",
		name: "Albanés",
		code: "ALB",
		value: "alb",
		image: "assets/img/alb.png",
	},
	{
		label: "BOSNIAN",
		name: "Bosnio",
		code: "BOS",
		value: "bos",
		image: "assets/img/bos.png",
	},
	{
		label: "ENGLISH",
		name: "Inglés",
		code: "ING",
		value: "ing",
		image: "assets/img/gbr.png",
	},
];
